import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { ArrowLeft, Users, Settings, LogOut, Lock, Globe } from 'lucide-react';

export const GroupHeader = ({ group, user, onJoin, onLeave }) => (
  <div className="bg-gradient-to-br from-primary/20 to-purple-500/20 border-b border-border">
    <div className="container mx-auto px-6 py-8">
      <Link to="/groups" className="text-muted-foreground hover:text-primary mb-4 inline-flex items-center gap-1">
        <ArrowLeft className="h-4 w-4" />
        Back to Groups
      </Link>

      <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mt-4">
        <div className="h-24 w-24 bg-black/50 flex items-center justify-center text-5xl border border-border">
          {group.is_private ? '🔒' : '💪'}
        </div>

        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h1 className="font-heading text-3xl text-white uppercase tracking-wider">{group.name}</h1>
            <Badge className={group.is_private ? 'bg-yellow-500/20 text-yellow-400' : 'bg-green-500/20 text-green-400'}>
              {group.is_private ? <><Lock className="h-3 w-3 mr-1" /> Private</> : <><Globe className="h-3 w-3 mr-1" /> Public</>}
            </Badge>
          </div>
          <p className="text-white/70 mb-3">{group.description}</p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span className="flex items-center gap-1">
              <Users className="h-4 w-4" />
              {group.member_count} members
            </span>
            {group.creator && <span>Created by {group.creator.name}</span>}
          </div>
        </div>

        <div className="flex gap-2">
          {group.is_member ? (
            <>
              {group.role === 'admin' && (
                <Button variant="outline" size="sm">
                  <Settings className="h-4 w-4 mr-1" />
                  Settings
                </Button>
              )}
              {group.creator_id !== user?.id && (
                <Button variant="outline" size="sm" onClick={onLeave} data-testid="leave-group-btn">
                  <LogOut className="h-4 w-4 mr-1" />
                  Leave
                </Button>
              )}
            </>
          ) : (
            <Button onClick={onJoin} className="bg-primary text-black" data-testid="join-group-btn">
              Join Group
            </Button>
          )}
        </div>
      </div>
    </div>
  </div>
);
